import { render, staticRenderFns } from "./EditStaff.vue?vue&type=template&id=2860cb0e&scoped=true"
import script from "./EditStaff.vue?vue&type=script&lang=js"
export * from "./EditStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2860cb0e",
  null
  
)

export default component.exports